import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Main from './pages/Main';
import MainMobile from './pages/MainMobile';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={window.innerWidth > 1140 ? <Main/> : <MainMobile />} />
      </Routes>
    </Router>
  );
}

export default App;
